export { PinsList } from './PinsList.component';
